export function buildAvailableRateKey(
  checkIn: string,
  checkOut: string,
  rooms: Array<App.Occupants>,
) {
  return `${checkIn}-${checkOut}-${rooms.map(room => `${room.adults}-${room.children}-${room.infants}-${room.teenagers}`).join('-')}`
}
